export const translations = {
  codRegional: {
    pt: "Código Regional",
    en: "Regional Code",
    de: "Regionalcode",
    es: "Código Regional",
  },
  nome: {
    pt: "Nome",
    en: "Name",
    de: "Name",
    es: "Nombre",
  },
};
